export default __webpack_public_path__ + "static/media/edit.8013d33a.svg";